import {post, get, put} from '@/utils/request';

export const list = (data) => get('/system/admin/page', data)

export const add = (data) => post('/system/admin/add', data)

export const update = (data) => put('/system/admin/edit', data)

export const detail = (id) => get(`/system/admin/detail/${id}`, null)

export const deletes = (data) => post(`/system/admin/del`, data)

// 重置密码
export const PassReset = (data) => post(`/system/admin/pass/reset`, data)

export const BoundDD = (query) => {
    return get('/system/admin/bound', query)
}
export const UnBoundDD = () => {
    return get('/system/admin/unbound', null)
}

export default {list, add, update, detail, deletes, PassReset, BoundDD, UnBoundDD}
